import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=01a40e02&scoped=true"
import script from "./main-content.vue?vue&type=script&lang=js"
export * from "./main-content.vue?vue&type=script&lang=js"
import style0 from "./main-content.vue?vue&type=style&index=0&id=01a40e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a40e02",
  null
  
)

export default component.exports